module.exports = __webpack_public_path__ + "static/015.thumb-0cae6d73b86d30409d86fa39339e4ef0.jpg";